<template>
  <div>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <b-row>
        <b-col sm="12">
          <h3>
            Mijn Gegevens
          </h3>
        </b-col>
      </b-row>
      <family-user-summary :person="family.person"/>
      <template v-if="family.partner.hasPartner">
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h3>
              Partner
            </h3>
          </b-col>
        </b-row>
        <family-user-summary :person="family.partner"/>
      </template>

      <b-row>
        <b-col sm="12">
          <br>
          <h3>
            Verhuizen er nog andere personen, zoals inwonende kinderen, mee?
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            Om te bepalen welke woningen passend zijn, is ook het aantal personen van het huishouden van belang. U kunt hier invullen welke personen nog meer mee verhuizen, zoals bijvoorbeeld inwonende kinderen, inwonende ouders, of andere huisgenoten.
          </p>
        </b-col>
      </b-row>

      <template v-for="(person, i) in family.extraPeople">
        <b-row class="person">
          <b-col sm="12">
            <h4>
              <span @click="removeExtraPerson(i)">
                Persoon {{ i + 1 }}
                  <i class="fad fax fa-trash remove-button fa-2x"></i>
              </span>
            </h4>
          </b-col>
        </b-row>
        <date-picker :min-age="0" v-model="person.dob" :valid="!highlightInvalid || validDate(person.dob)"/>

        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fal fax fa-people-arrows"></i>
            <label>Relatie tot aanvrager(s)*</label>
          </b-col>
          <b-col sm="6">
            <b-form-select
                    :options="formData.relation"
                    v-model="person.relation"
                    :state="person.relation !== '' ? true : !highlightInvalid ? null : false"
                    required
            />
          </b-col>
        </b-row>

        <b-row v-if="person.relation === 'Ouder' || person.relation === 'Overige bewoner'">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-wallet"></i>
            <label>Inkomen*</label>
          </b-col>
          <b-col sm="6">
            <b-input
                type="text"
                v-model="person.income"
                @change="onIncomeChange(person)"
                :state="person.income !== '€ 0,-' && person.income !== '' ? true : !highlightInvalid ? null : false"
                required
            />
          </b-col>
          <b-col offset-sm="2" sm="9" offset-xl="5" xl="6">
            <div class="disconnectedButtons">
              <b-button variant="info" size="sm" class="pull-left" @click="setCalculatorState(true, person)">
                Rekenhulp
              </b-button>
              <b-button variant="info" size="sm" class="pull-left" @click="$bvModal.show('bdPopup')">
                Belastingdienst
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>

      <b-row>
        <b-col sm="11">
          <br class=".d-block .d-sm-none">
          <b-button variant="success" size="sm" class="text-center" @click.stop="addExtraPerson">
            Voeg persoon toe
          </b-button>
        </b-col>
      </b-row>

      <br>
      <error-box v-if="postErrors.length > 0" :errors="postErrors"/>

      <FormButtons @next="next" @previous="$emit('previous')"/>
    </template>

    <IncomeCalculator
            :open="calculatorModal"
            @calculatorClosed="setCalculatorState(false)"
            @calculatorEmitVal="setValueFromCalculator">
    </IncomeCalculator>
  </div>
</template>

<script>
import FormButtons from '@/components/_registration/FormButtons'
import FamilyUserSummary from '@/components/_registration/FamilyUserSummary'
import FormLoader from '@/components/_registration/FormLoader'
import { registrationService } from '@/_services/registration.service'
import DatePicker from '@/components/DatePicker'
import { validDate } from '@/_helpers/validators'
import ErrorBox from '@/components/_registration/ErrorBox'
import { formatIncome } from '@/_helpers/transformers'
import IncomeCalculator from './IncomeCalculator'

export default {
  components: { FormButtons, FamilyUserSummary, FormLoader, DatePicker, ErrorBox, IncomeCalculator},
  data: () => {
    return {
      postErrors: [],
      highlightInvalid: false,
      calculatorModal: false,
      calculatorFocus: '',
      formData: {
        relation: [
          { text: 'Kies relatie...', value: '' },
          { text: 'Kind', value: 'Kind' },
          { text: 'Ouder', value: 'Ouder' },
          { text: 'Overige bewoner', value: 'Overige bewoner' },
        ],
      },

      loading: false,
      family: {
        person: {
          registrationnumber: '',
          initials: '',
          lastname: '',
        },
        partner: {
          hasPartner: false,
          registrationnumber: '',
          initials: '',
          lastname: ''
        },
        extraPeople: [],
      },
    }
  },
  name: 'Family',
  computed: {
    validated () {
      let valid = true
      this.family.extraPeople.forEach(function (item, index) {

        if (!validDate(item.dob)) {
          valid = false
        }

        if (item.relation === '') {
          valid = false
        }
      })
      return valid
    },
  },
  watch: {
    validated (val) {
      this.$emit('validated', val)
    },
  },
  methods: {
    fetchFamily () {
      this.loading = true
      registrationService.getFamily().then(result => {

        this.family.person = result.person
        this.family.partner = result.partner
        this.family.extraPeople = result.extraPeople.info
        this.family.extraPeople.forEach((a,b) => {
          this.family.extraPeople[b].income = formatIncome(this.family.extraPeople[b].income)
        })

      }).finally(() => {
        this.loading = false
      })
    },
    removeExtraPerson (index) {
      this.family.extraPeople.splice(index, 1)

    },
    addExtraPerson () {
      this.family.extraPeople.push({
        dob: '',
        relation: '',
        income: formatIncome(0)
      })
    },
    validDate: validDate,

    setCalculatorState (tog, focus) {
      this.calculatorModal = tog
      this.calculatorFocus = focus
    },

    setValueFromCalculator (income) {
      this.calculatorFocus.income = formatIncome(income)
    },

    submit() {
      this.family.extraPeople.forEach((a,b) => {
        this.family.extraPeople[b].income = this.family.extraPeople[b].income.replace(/[^0-9]/g, '')
      })
      registrationService.postFamily(this.family.extraPeople).then(result => {
        if ('errors' in result) {
          this.postErrors = result.errors
        } else {
          this.postErrors.errors = []
          this.$emit('next')
        }
      })
    },

    next () {
      this.highlightInvalid = true
      if (this.validated) {
        this.$emit('validated', true)
        this.submit()
      }
    },

    onIncomeChange(person) {
      person.income = formatIncome(person.income)
    },
  },
  activated () {
    this.fetchFamily()
  },

  mounted () {
    this.fetchFamily()
    if(this.$store.state.registration.errors[this.$options.name] !== undefined) {
      this.highlightInvalid = true
    }
  }
}
</script>

<style scoped>
.remove-button {
  color: red;
  cursor: pointer;
  margin-left: 25px;
}

.remove-button:hover {
  color: #b30606;
}

.person {
  margin-top: 10px;
}
</style>
